import React from 'react';

import { Alert, Typography } from 'vindi-ds-components';

function PriceRangeErrorsAlert({ style, title, errors }) {
  const uniqueErros = [...new Set(errors)].filter((e) => e);
  if (errors.length) {
    return (
      <Alert style={style} severity='error'>
        <Typography variant='subtitle1'>{title}</Typography>
        {uniqueErros.map((err) => (
          <Typography variant='subtitle2' color='error'>{err}</Typography>
        ))}
      </Alert>
    );
  }

  return null;
}

export default PriceRangeErrorsAlert;
